import RestClient from '../../../../api/axiosInterceptor';
import { hospitalGoogleAuthActions } from '../../../actions/user/hospital/Account/googleAuth';
import {
	setHospitalCredentials,
	setHospitalAuthenticated,
} from '../../../actions/user/hospital/Account/login';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function that receives dispatch.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
	try {
		// Dispatch the request action
		dispatch({ type: actionType.REQUEST });

		// Make the API call
		const response = await apiCall(dispatch);

		// Dispatch success action with response data
		dispatch({
			type: actionType.SUCCESS,
			payload: response.data,
		});

		return response;
	} catch (error) {
		// Dispatch failure action if an error occurs
		dispatch({
			type: actionType.FAILURE,
			payload: error.response?.data?.message || error.message,
		});

		throw error;
	}
};

/**
 * Authenticate a patient using Google account
 * @param {Object} googleData - Google user info and token
 * @returns {Function} - Thunk action
 */

export const hospitalGoogleLogin = (googleData) =>
	createAsyncAction(
		hospitalGoogleAuthActions.GOOGLE_LOGIN,
		async (dispatch) => {
			const response = await RestClient.post('/hospital/google-auth/login/', {
				token: googleData.token,
				email: googleData.userInfo.email,
				name: googleData.userInfo.name,
			});

			if (response.data.token) {
				// Store credentials and auth state in localStorage for persistence
				localStorage.setItem('hospitalCredentials', response.data.token);
				localStorage.setItem('isAuthenticated', 'true');

				// Update auth state in Redux
				dispatch(setHospitalAuthenticated(true));
				dispatch(setHospitalCredentials(response.data.token));
			}

			return response;
		},
	);

/**
 * Register a new patient using Google account
 * @param {Object} googleData - Google user info and token
 * @returns {Function} - Thunk action
 */
export const hospitalGoogleRegister = (googleData) =>
	createAsyncAction(
		hospitalGoogleAuthActions.GOOGLE_REGISTER,
		async (dispatch) => {
			const response = await RestClient.post(
				'/hospital/google-auth/registration/',
				{
					token: googleData.token,
					email: googleData.userInfo.email,
					name: googleData.userInfo.name,
				},
			);
			if (response.data.token) {
				// Store credentials and auth state in localStorage for persistence
				localStorage.setItem('hospitalCredentials', response.data.token);
				localStorage.setItem('isAuthenticated', 'true');

				// Update auth state in Redux
				dispatch(setHospitalAuthenticated(true));
				dispatch(setHospitalCredentials(response.data.token));
			}

			return response;
		},
	);
